import CutwiseAPIClient, { METHOD_GET, METHOD_POST } from '@/common/network/CutwiseAPIClient';
export const PATH_MY_ALERTS = 'api/alert/my';
export const PATH_READ_ALERT = 'api/alert/read';
export default class AlertAPI {
    getAlerts() {
        const qb = CutwiseAPIClient.createQueryBuilder().method(METHOD_GET).path(PATH_MY_ALERTS);
        const query = qb.getQuery();
        return CutwiseAPIClient.sendQuery(query);
    }
    readAlert(id) {
        const qb = CutwiseAPIClient.createQueryBuilder().method(METHOD_POST).path(`${PATH_READ_ALERT}/${id}`);
        const query = qb.getQuery();
        return CutwiseAPIClient.sendQuery(query);
    }
}
